import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import { footerGroups, hotKeywords, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-900 text-background-100">
      <Container>
        <div className="grid grid-cols-1 gap-10 py-14 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-2 lg:pr-12">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-trophy-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/85">
              {siteInfo.description}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {hotKeywords.map((word) => (
                <span
                  key={word}
                  className="rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-200/90"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {group.title}
              </h3>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-200/85 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-6 border-t border-background-50/15 py-8 md:grid-cols-2">
          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">联系我们</h3>
            <ul className="mt-3 space-y-2 text-sm text-background-200/85">
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line text-base text-accent-400" />
                </span>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-briefcase-line text-base text-accent-400" />
                </span>
                商务合作：{siteInfo.mediaEmail}
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-calendar-line text-base text-accent-400" />
                </span>
                {siteInfo.updateFrequency}
              </li>
            </ul>
          </div>
          <div className="text-sm text-background-200/70 md:text-right">
            <p>本站内容为娱乐行业现象的观察与解读，不构成对任何个人的评价或定论。</p>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-50/15 py-6 text-xs text-background-200/70 sm:flex-row">
          <p>
            © {year} {siteInfo.name} · 保留所有权利
          </p>
          <p>自 {siteInfo.founded} 年起专注跨界对比与热度观察</p>
        </div>
      </Container>
    </footer>
  );
}